import script from "./Copyright.vue?vue&type=script&lang=ts&setup=true"
export * from "./Copyright.vue?vue&type=script&lang=ts&setup=true"

import "./Copyright.vue?vue&type=style&index=0&id=2d13d805&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d13d805"]])

export default __exports__